// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"27":"b2ba9d18","511":"fd7848dc","727":"fbb4d518","810":"d39379ed"}[chunkId] + ".css";
};